export default function ContactUs() {
  return (
    <main className="page-content">
      <div className="container" style={{ maxWidth: 760 }}>
        <h1 className="page-title">Get in touch</h1>
        <p className="page-subtitle">Questions, feedback, bug reports — we read every email.</p>

        <div style={{
          background: 'linear-gradient(180deg, #F8FAFC 0%, #FFFFFF 100%)',
          border: '1px solid var(--line)',
          borderRadius: 22,
          padding: '32px 36px',
          marginBottom: 36,
          display: 'flex',
          alignItems: 'center',
          gap: 24,
          flexWrap: 'wrap',
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: 16,
            background: 'linear-gradient(180deg, #6EC6F5 0%, #7C3AED 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '1.8rem',
            boxShadow: '0 6px 0 #5B21B6',
            flexShrink: 0,
          }}>✉️</div>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div style={{ fontSize: '0.85rem', color: 'var(--ink-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>
              Email us
            </div>
            <a href="mailto:webmalik3@gmail.com" style={{
              fontFamily: "'Baloo 2', sans-serif",
              fontSize: '1.4rem',
              fontWeight: 800,
              color: 'var(--sky-bot)',
              wordBreak: 'break-all',
            }}>
              webmalik3@gmail.com
            </a>
            <div style={{ fontSize: '0.85rem', color: 'var(--ink-muted)', marginTop: 6 }}>
              We typically respond within 24–48 hours.
            </div>
          </div>
          <a href="mailto:webmalik3@gmail.com" className="btn-3d purple">
            Send a message
          </a>
        </div>

        <div className="legal-section">
          <h2>What to include</h2>
          <p>So we can help faster, please mention:</p>
          <ul>
            <li>Your in-app username (we never ask for your password)</li>
            <li>Your device — iPhone or Android model + OS version</li>
            <li>The GuessUp app version (Settings → About → Version)</li>
            <li>A clear description of your question, idea, or issue</li>
            <li>Screenshots if you're reporting a bug or unexpected behavior</li>
          </ul>

          <h2>Common reasons people email us</h2>
          <ul>
            <li><strong>Account & data deletion</strong> — we'll process your request within 30 days.</li>
            <li><strong>Bug reports</strong> — describe what happened, what you expected, and the steps to reproduce.</li>
            <li><strong>Feature ideas</strong> — we genuinely use this feedback to plan the roadmap.</li>
            <li><strong>Reporting another player</strong> — include the username and a brief description; we treat reports confidentially.</li>
            <li><strong>Press, business, partnerships</strong> — start your subject line with "Business —" so it gets to the right inbox quickly.</li>
          </ul>

          <h2>Response time</h2>
          <p>We're a small team. We aim to reply within 24–48 hours on weekdays. Account deletion requests are processed within 30 days as required by privacy law.</p>

          <h2>Find us elsewhere</h2>
          <p>For privacy questions, see our <a href="/privacy-policy" style={{ color: 'var(--sky-bot)', fontWeight: 600 }}>Privacy Policy</a>. For app usage rules, see our <a href="/terms-and-conditions" style={{ color: 'var(--sky-bot)', fontWeight: 600 }}>Terms & Conditions</a>.</p>
        </div>
      </div>
    </main>
  );
}
